import { useEffect, useRef, useState } from "react"
import { ConsultaCodigoBarras } from "../funcionalidades/bancoGet";
import Swal from "sweetalert2";

import '../../assets/css/pdfProdutoImpressao.css'
import JsBarcode from "jsbarcode";
import GlobalVar from "../subComponents/GlobalVar";


const dividirProdutosPorGrupos = (produto, posicao, limitePorGrupo = 30) => {
    const produtoTMP = {'0':{
        produtos_id: 0,
        vazio: true,
        quantidade: posicao,
      },...produto}
    
      console.log(produtoTMP)
    const resultado = [];
    let grupoAtual = [];
    let quantidadeAtual = 0;
  
    for (const produto of Object.values(produtoTMP)) {
        console.log(produto)
      let quantidadeRestante = parseInt(produto.quantidade);
  
      while (quantidadeRestante > 0) {
        const espacoDisponivel = limitePorGrupo - quantidadeAtual;
  
        if (quantidadeRestante <= espacoDisponivel) {
          grupoAtual.push({ ...produto, quantidade: quantidadeRestante });
          quantidadeAtual += quantidadeRestante;
          quantidadeRestante = 0;
        } else {
          grupoAtual.push({ ...produto, quantidade: espacoDisponivel });
          quantidadeRestante -= espacoDisponivel;
          quantidadeAtual = limitePorGrupo;
        }
  
        if (quantidadeAtual === limitePorGrupo) {
          resultado.push(grupoAtual);
          grupoAtual = [];
          quantidadeAtual = 0;
        }
      }
    }
  
    // Verifica se há itens restantes no último grupo e se é menor que o limite
    if (grupoAtual.length > 0) {
      if (quantidadeAtual < limitePorGrupo) {
        grupoAtual.push({
          produtos_id: 0,
          vazio: true,
          quantidade: limitePorGrupo - quantidadeAtual,
        });
      }
      resultado.push(grupoAtual);
    }
    
    return resultado;
  };
  


const dividirProdutosPorColunas = (produto) => {
    const produtoTMP = {...produto}
    const grupos = [];
    let grupoAtual = [];
    let quantidadeAtual = 0;

    Object.values(produtoTMP).forEach((item) => {
        let quantidadeRestante = parseInt(item.quantidade, 10); // Garantir que é número

        while (quantidadeRestante > 0) {
            const quantidadeParaAdicionar = Math.min(quantidadeRestante, 10 - quantidadeAtual);

            grupoAtual.push({
                ...item,
                quantidade: quantidadeParaAdicionar,
            });

            quantidadeAtual += quantidadeParaAdicionar;
            quantidadeRestante -= quantidadeParaAdicionar;

            // Se o grupo atingir 30 unidades, finaliza e começa um novo
            if (quantidadeAtual === 10) {
                grupos.push(grupoAtual);
                grupoAtual = [];
                quantidadeAtual = 0;
            }
        }
    });

    // Adiciona o último grupo, se houver itens restantes
    if (grupoAtual.length > 0) {
        grupos.push(grupoAtual);
    }

    return grupos;
};

const PrintEtiqueta = ({etiquetas})=>{
    const etiquetaList = []
    for (let i = 0; i < parseInt(etiquetas.quantidade); i++){
        etiquetaList.push(<EtiquetaItem key={"etiqueta"+etiquetas.produtos_id+""+i} item={etiquetas}/>)
    }
    return etiquetaList
}
const EtiquetaItem = ({item})=>{
    const barcodeRef = useRef(null);

    useEffect(() => {
        if (barcodeRef.current && !item.vazio) {
        JsBarcode(barcodeRef.current, item.etiqueta, {
            displayValue: false,
            height: 80,
            margin: 0,
        });
        }
    }, [item]);

    if(item.vazio){
        return <div className="etiqueta"></div>
    }else{
        return <div className="etiqueta">
            <svg className="barcode" ref={barcodeRef}></svg>
            <div className="descPrinc">
                <div>{item.produtos_item+" "+(item.rev_num_rev ? 
                
                item.produtos_descricao.length >= 11 ? item.produtos_descricao.substring(0, 13).split("-").join('') : item.produtos_descricao
                : item.produtos_descricao.substring(0, 18))+""+(
                    item.produtos_descricao.length <= 10 && item.rev_num_rev && item.nomerevmenor != item.procor_descricao_cor ? " - "+item.nomerevmenor : "")} </div>
                <div>{item.tam_nom}</div>
            </div>

            <div className="descPrinc">
                <div>{item.produtos_codigo + " "+item.for_nomfant.substring(0, 11)}</div>
                <div>{item.produtos_dbasica + "-" +item.descbasica_nome.substring(0, 12)}</div>
            </div>

            <div className="descPrinc">
            <div>D8X{(parseFloat(item.produtos_preco)*2).toString().split(".").join('/')+" "+(item.procor_descricao_cor ? item.procor_descricao_cor : item.rev_nom).substring(0, 10)}</div> 
            <div>{item.produtos_pagina === 0 || item.produtos_pagina === "0" ? '' : `PAG : ${item.produtos_pagina}`}</div>
            </div>
        </div>
    }
}

export default function GeraPdfProdutoImpressao({ativaResp}){
    
    useEffect(() => {
        // Adiciona a classe ao <body> ao montar o componente
        document.body.classList.add('papelEtiquetaBody');
    
        // Remove a classe ao desmontar o componente
        return () => {
          document.body.classList.remove('papelEiquetaBody');
        };
      }, []); // Reexecuta o efeito se a classe mudar


    // const [quantidadeTotal, setQuantidadeTotal] = useState(null)

    const [codigoBarras, setCodigoBarras] = useState(false)
    const [produtoCodBarra, setProdutoCodBarra] = useState(null)
    const [produtoDividido, setProdutoDividido] = useState([])
    
    const produtos = GlobalVar.getLocalStorage("produtoImpressaoEtiquetaPDF")
    const posicao = GlobalVar.getLocalStorage("posicaoImpressaoEtiquetaPDF")

    const usuario = GlobalVar.getLocalStorage('usuario')
    


    useEffect(() => {
        let isMounted = true; // Flag para garantir execução única
        (async () => {
            if (!produtos || !isMounted || !posicao) return;
            let tempProduct = await  {...produtos}
            for(let key of Object.keys(tempProduct)){
                await ConsultaCodigoBarras({item: tempProduct[key].produtos_num_item, for_cod: tempProduct[key].produtos_num_fornecedor})
                    .then((resp)=>{
                        if(resp.Error || resp['ERROR SERVER']){
                            Swal.fire({
                                icon: "warning",
                                title: "Algo deu errado",
                                text: "Problema no servidor."
                                });
                        }else{
                            tempProduct[key].etiqueta =  resp[0].etiqueta
                        }
                    })
            }
        
        await setProdutoCodBarra(tempProduct)
        await setCodigoBarras(true)
        
    })();

    return () => {
        isMounted = false; // Cleanup para evitar repetição
    };

    }, [])

    useEffect(()=>{
        if(codigoBarras && produtoCodBarra){
            // setQuantidadeTotal(Object.values(produto).reduce((prev, curr)=> {
            //     return {quantidade: parseInt(prev.quantidade) + parseInt(curr.quantidade)}
            // }, {quantidade: 0}).quantidade)
            setProdutoDividido(dividirProdutosPorGrupos(produtoCodBarra, posicao !== "" ? posicao-1 < 0 ? 0 : posicao-1 : 1))
        }
    },[codigoBarras,produtoCodBarra])

    useEffect(()=>{
        if(codigoBarras && ativaResp){       
            setTimeout(()=>{window.print()}, 1500)
        }
    },[codigoBarras, ativaResp])



    if(!codigoBarras) { return <></> }

    return        <>
          {/* <button onClick={gerarPDF}>Gerar PDF</button> */}
    
            <div className={`pdfProdutoImpressao`}>
        
                {produtoDividido ? produtoDividido.map((page, index)=>{
                    
                    return <div className={`pageProd page${index}`} key={"page"+index} style={usuario ? usuario.for_cod == 153192 || usuario.for_cod == 140457 ? { pageBreakAfter: 'unset'} : {} : {}}>
        
                            {dividirProdutosPorColunas(page).map((coluna, indexColuna)=>{
                                return <div className={`colunaProd coluna${indexColuna}`} key={"coluna"+indexColuna}>
                                    {Object.values(coluna).map((etiquetas, indexEtiqueta)=> <PrintEtiqueta etiquetas={etiquetas} key={`printEtiqueta${indexEtiqueta}`} />)}
                                </div>
                            })}
                            
                    </div>
                }) : <></>}
            </div>
          
        </>
      
    
    

}